/**
 * MSAL Configuration for Azure AD Authentication
 *
 * This configuration enables Single Sign-On with Azure AD for medical auditors.
 */
import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';

// Azure AD Application Configuration
const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '6e6b996f-b0c6-433e-81f0-3873ef06b338';
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '2970bf92-0acf-4cb5-87e6-95bf50245322';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

// Validate required configuration
if (!AZURE_CLIENT_ID || AZURE_CLIENT_ID === '') {
  console.error('MSAL Configuration Error: REACT_APP_AZURE_CLIENT_ID is not set');
}
if (!AZURE_TENANT_ID || AZURE_TENANT_ID === '') {
  console.error('MSAL Configuration Error: REACT_APP_AZURE_TENANT_ID is not set');
}

/**
 * MSAL Configuration
 * @see https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage', // Persist session across tabs
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
          case LogLevel.Info:
            // Uncomment for debug: console.info('[MSAL]', message);
            break;
          case LogLevel.Verbose:
            // Uncomment for debug: console.debug('[MSAL]', message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes for ID token and access token requests
 * - User.Read: Required to fetch user profile and photo from Microsoft Graph
 * Note: openid, profile, email are requested implicitly by MSAL
 */
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

/**
 * Scopes for Microsoft Graph API calls
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};

/**
 * Auditor role ID from Azure AD App Registration
 */
export const AUDITOR_ROLE_ID = '0ca98305-489e-417e-83b9-90955b67f909';
export const AUDITOR_ROLE_VALUE = 'Auditor';
